import $http from "../axios";

const state = {
  isAuthenticated: false,
  sessionToken: "",
  certificates: null
};

const getters = {
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  sessionToken(state) {
    return state.sessionToken;
  },
  certificates(state) {
    return state.certificates;
  }
};

const actions = {
  login({ commit }, credentials) {
    commit("LOGOUT");
    return new Promise((resolve, reject) => {
      $http
        .post("/login", {
          email: credentials.email,
          password: credentials.password
        })
        .then(res => {
          if (res.data.result === "ok") {
            commit("LOGIN_SUCCESS", res.data.payload.sessionToken);
            commit("SET_PERMISSIONS", res.data.payload.permissions);
            commit("SET_ROLE", res.data.payload.role);
            commit("SET_CERTIFICATES", res.data.payload.certificates);
          } else {
            commit("LOGOUT");
          }
          resolve(res);
        })
        .catch(e => {
          commit("LOGOUT");
          reject(e);
        });
    });
  },

  logout({ commit }) {
    commit("LOGOUT");
  },

  forgotPassword(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("/forgot-password", {
          email: data.email
        })
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  definePassword(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("/define-password", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  resetPassword(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("/reset-password", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  LOGIN_SUCCESS(state, sessionToken) {
    state.isAuthenticated = true;
    state.sessionToken = sessionToken;
  },

  LOGOUT(state) {
    state.isAuthenticated = false;
    state.sessionToken = "";
    state.certificates = [];
  },

  SET_CERTIFICATES(state, certificates) {
    state.certificates = certificates;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
